import * as React from "react"

function StoreIcon({...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
      style={{
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      fill="#25b39e"
      d="M7.513 1033.935a2.938 2.938 0 0 1-1.5.427v12h11v-12.209c-.17-.065-.344-.126-.5-.219a2.938 2.938 0 0 1-1.5.428 2.938 2.938 0 0 1-1.5-.428 2.938 2.938 0 0 1-1.5.428 2.938 2.938 0 0 1-1.5-.428 2.938 2.938 0 0 1-1.5.428 2.938 2.938 0 0 1-1.5-.428z"
      color="#000"
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      d="M4.014 1031.342v16.488h1v-16.488h-1zm24 0v17.02h-9.285v1h9.785a.5.5 0 0 0 .5-.5v-17.52h-1zm-23.073-9.98a.5.5 0 0 0-.466.322l-3.428 9 .933.357 3.307-8.68H27.74l3.307 8.68.933-.357-3.427-9-.469.677v-1H4.941z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M1.514 1047.361a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .345.475.5.5 0 0 0 .05.014.5.5 0 0 0 .097.012.5.5 0 0 0 .008 0h17a.5.5 0 0 0 .1-.01.5.5 0 0 0 .4-.49v-3l-.008.01a.5.5 0 0 0-.492-.508h-17zm.5 1h16v2h-16v-2z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M18.52 1048.361a.5.5 0 0 0-.493.508l-.007-.01v2a.5.5 0 0 0 .5.5h10.472v-1H19.02v-1h9.972v-1H18.52z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M28.514 1047.361a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .345.475.5.5 0 0 0 .05.014.5.5 0 0 0 .097.012.5.5 0 0 0 .008 0h3a.5.5 0 0 0 .1-.01.5.5 0 0 0 .4-.49v-3l-.008.01a.5.5 0 0 0-.492-.508h-3zm.5 1h2v2h-2v-2zm-24.518-17.52a.5.5 0 0 0-.492.507v16.45a.5.5 0 1 0 1 0v-16.45a.5.5 0 0 0-.508-.506zm14.02 1.448a.5.5 0 0 0-.493.508v16.064a.5.5 0 1 0 1 0v-16.064a.5.5 0 0 0-.507-.508zm1.998 6.072a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-10.524l-.5.02zm.5 1h5v9h-5z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M1.506 1030.365a.5.5 0 0 0-.492.506v.49c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1v-.49a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M4.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M7.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M10.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M13.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M16.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M19.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M22.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M25.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M31.506 1030.313a.5.5 0 0 0-.492.507v.541c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 1 0-1 0c0 1.1.9 2 2 2 1.099 0 2-.9 2-2v-.54a.5.5 0 0 0-.508-.508z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      fillRule="evenodd"
      d="M22.014 1042.361v2h1v-2h-1zm-13.448-7.222-2 4 .895.447 2-4-.895-.447zm2 2-2.5 5 .895.447 2.5-5-.895-.447z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path
      d="M4.941 1021.361a.5.5 0 0 0-.466.323l-3.428 9 .933.357 3.307-8.68H27.74l3.307 8.68.933-.357-3.427-9-.006.01a.5.5 0 0 0-.463-.33H4.94z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M1.506 1030.365a.5.5 0 0 0-.492.506v.49c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1v-.49a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M4.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M7.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M10.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M13.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M16.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M19.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M22.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M25.506 1030.855a.5.5 0 0 0-.492.506c0 1.1.9 2 2 2 1.099 0 2-.9 2-2a.5.5 0 1 0-1 0c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 0 0-.508-.506z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      d="M31.506 1030.313a.5.5 0 0 0-.492.507v.541c0 .563-.438 1-1 1-.563 0-1-.437-1-1a.5.5 0 1 0-1 0c0 1.1.9 2 2 2 1.099 0 2-.9 2-2v-.54a.5.5 0 0 0-.508-.508z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        msBlockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      transform="translate(0 -1020.362)"
    />
    <path
      style={{
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      fill="#f8b84e"
      d="m5.976 1023.362-2.77 7.27a1.5 1.5 0 0 1 1.307-.77 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1 .002-.09 1.5 1.5 0 0 1 2.803-.644l-2.767-7.266H5.976zm-2.927 7.684-.036.094v.203a1.5 1.5 0 0 1 .036-.297zm26.93 0a1.5 1.5 0 0 1 .034.297v-.204l-.035-.094zm.034.316c0 .034-.036.054-.037.088h.036l.002-.088z"
      color="#000"
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    <path fill="#25b39e" fillRule="evenodd" d="M22.013 21v-1h3v7h-3v-2h2v-4z" />
    <path
      style={{
        isolation: "auto",
        mixBlendMode: "normal",
      }}
      fill="#25b39e"
      d="M22.513 1033.935a2.938 2.938 0 0 1-1.5.427c-.354 0-.684-.088-1-.209v3.21h7v-3a2.938 2.938 0 0 1-1.5-.429 2.938 2.938 0 0 1-1.5.428 2.938 2.938 0 0 1-1.5-.428z"
      color="#000"
      overflow="visible"
      transform="translate(0 -1020.362)"
    />
    </svg>
  )
}

export default StoreIcon